// extracted by mini-css-extract-plugin
module.exports = {"programBtnWrapper":"Item_programBtnWrapper__3daAP","cell":"Item_cell__1w5nE","removeCell":"Item_removeCell__1o58p","icon":"Item_icon__2WqNP"};